export default [
  "requisitionsInformation",
  "patientInformation",
  "patientHistory",
];
